import React from "react";
import clsx from "clsx";

import styles from "./PageHeader.module.css";

type PageHeaderProps = {
  title: string;
  subtitle: React.ReactNode;
  align?: "left" | "center";
  compact?: boolean;
};

function PageHeader({
  title,
  subtitle,
  align = "left",
  compact = false,
}: PageHeaderProps) {
  const centered = align === "center";

  return (
    <header
      className={clsx(styles.header, compact && styles.headerCompact)}
      data-align={centered ? "center" : undefined}
    >
      <h1 className={styles.title}>{title}</h1>
      <p className={styles.subtitle}>{subtitle}</p>
    </header>
  );
}

export default PageHeader;
